import { PedidoItem, PedidoItemDto } from '../../../../src/app/shared/model';
import { EmpleadoAsistencia } from "./empleado";

export class DialogTextoLibreRequest {
  constructor(
    public readonly Title: string | null,
    public readonly Message: string | null,
    public readonly ButtonTextAccept: string | null,
    public readonly ButtonTextCancel: string | null,
    public readonly Maxlength: number
  ) {}
}


export class DialogTextoLibreResponse {
  constructor(
    public readonly Result: string | null,
    public readonly Cancelled: boolean
  ) {}
}

export class DialogConfirmRequest {
  constructor(
    public readonly Title: string | null,
    public readonly Message: string | null,
    public readonly ButtonTextAccept: string | null,
    public readonly ButtonTextCancel: string | null,
    public readonly ShowButtonTextAccept: boolean = true,
    public readonly ShowButtonTextCancel: boolean = true
  ) {}
}

export class DialogConfirmResponse {
  constructor(
    public readonly Accepted: boolean
  ) {}
}

export class DialogModificarFechaRequest {
  constructor(
    public readonly Id: number,
    public readonly EmpleadoId: number,
    public readonly ComunidadId: number,
  ) {}
}

export class DialogPedidoEditRequest {
  constructor( 
    public readonly PedidoItem: any,
    public readonly TipoMaterialId: number,
  ) {}
}
export class DialogPedidoEditResponse {
  constructor( 
    public readonly PedidoItem: PedidoItemDto,    
  
  ) {}
}
export class DialogMotivoInasistenciaRequest {
  constructor(
    public readonly EmpleadoId: number,
    public readonly TipoAsistencia: number,
    public readonly FechaSeleccionada: string | null,
    public readonly FechaAsistencia: string | null,
    public readonly ObraSeleccionada: string | null,
    public readonly EsDia: boolean,
    public readonly ListaAsistencia: EmpleadoAsistencia[],
  ) {}
}

export class DialogMotivoInasistenciaResponse {
  constructor(
    public readonly MotivoInasistenciaId: number | null,
    public readonly HorasAsistencia: number | null,
    public readonly EmpleadoId: number | null,
    public readonly FechaAsistencia: string | null,
    public readonly TipoAsistencia: number | null,
    public readonly Accepted: boolean,
    public readonly EsDia: boolean | null
  ) {}
}

